import { mprConstants } from '../Constants'
const mprReducer = (state = {}, action) => {
  switch (action.type) {
    case mprConstants.MPR_SUCCESS:
      return action.payload;
    case mprConstants.MPR_FAILURE:
      return {};
    default:
      return state;
  }
}

export default mprReducer;